import type React from 'react';

import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { ResponsiveBox } from '#src/app/pages/petitionDetails/shared/components';
import type { AiGeneratedPetitionPhoto, PetitionPhoto } from '#src/app/pages/petitionDetails/shared/types';

import { AddMedia } from '../AddMedia';

import { AiHeroPhoto } from './components/AiHeroPhoto';
import { Photo } from './components/Photo';
import { PhotoMobile } from './components/PhotoMobile';
import { PhotoProcessing } from './components/PhotoProcessing';

type Props = {
	photo?: PetitionPhoto;
};

function isAiGeneratedPhoto(photo: PetitionPhoto): photo is AiGeneratedPetitionPhoto {
	return photo.aiGenerated;
}

export const HeadingMedia: React.FC<Props> = ({ photo }) => {
	const {
		data: { canEdit },
	} = usePetitionDetailsPageUserData();

	if (photo) {
		if (photo.processing) {
			return <PhotoProcessing />;
		}

		// AI-generated heroes render through the watermarking path
		if (isAiGeneratedPhoto(photo)) {
			return <AiHeroPhoto photo={photo} />;
		}

		return (
			<>
				<ResponsiveBox viewportSize="small">
					<PhotoMobile id="petition-photo-mobile" url={photo.url} mobileUrl={photo.mobileUrl} />
				</ResponsiveBox>

				<ResponsiveBox viewportSize="normal">
					<Photo id="petition-photo" url={photo.url} mobileUrl={photo.mobileUrl} />
				</ResponsiveBox>
			</>
		);
	}

	if (canEdit) {
		return <AddMedia />;
	}

	return null;
};
